import React, { useState } from 'react';
import {
  loginWithAccount,
  saveTokens,
  saveAccount,
  getCurrentUserInfo
} from '../services/authService';
import './Login.css';

const Login = ({ onLoginSuccess }) => {
  const [account, setAccount] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // 调用登录 API
      const data = await loginWithAccount(account, password);

      // 保存 tokens
      saveTokens(data.access_token, data.refresh_token);
      saveAccount(account);

      // 获取用户信息
      await getCurrentUserInfo(account);

      // 登录成功回调
      if (onLoginSuccess) {
        onLoginSuccess(data);
      }

    } catch (err) {
      setError(err.message || '登录失败，请检查账号和密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="bubble bubble-1"></div>
        <div className="bubble bubble-2"></div>
        <div className="bubble bubble-3"></div>
        <div className="bubble bubble-4"></div>
      </div>

      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">欢迎回来</h1>
          <p className="login-subtitle">登录继续你的游戏</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <label htmlFor="account" className="input-label">
              手机号
            </label>
            <input
              id="account"
              type="text"
              className="input-field"
              placeholder="请输入手机号"
              value={account}
              onChange={(e) => setAccount(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <label htmlFor="password" className="input-label">
              密码
            </label>
            <input
              id="password"
              type="password"
              className="input-field"
              placeholder="请输入密码"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠</span>
              {error}
            </div>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <span className="loading-spinner"></span>
            ) : (
              '登录'
            )}
          </button>
        </form>

        <div className="login-footer">
          <a href="#forgot" className="footer-link">忘记密码？</a>
          <span className="footer-divider">|</span>
          <a href="#register" className="footer-link">注册账号</a>
        </div>
      </div>
    </div>
  );
};

export default Login;
